import React, { Component } from 'react';
import { RootState } from '../../../redux/store';
import { StreamState } from '../../../redux/reducers/StreamReducer';
import { changeStream, changeStreamIsUpdate } from '../../../redux/actions/StreamActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import { AccessBase } from '../../../domain/access/BaseAccess';
import AccessContainer from '../../access/AccessContainer';
import RoleHelper from '../../../RoleHelper';

class StreamAccessComponent extends Component<Props> {
  render() {
    const {
      stream: { stream },
    } = this.props;
    const access: AccessBase = { permission: stream.permission, collaborators: stream.collaborators };
    return <AccessContainer access={access} changeAccess={this.changeAccess} disabled={!RoleHelper.canManage('Stream')} />;
  }

  private changeAccess = (access: AccessBase) => {
    const {
      stream: { stream },
      changeStream,
    } = this.props;
    stream.permission = access.permission;
    stream.collaborators = access.collaborators;
    changeStream(stream);
  };
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  stream: state.stream as StreamState,
  lastCategory: state.page.lastCategory,
});

const mapDispatchToProps = { changeStream, changeStreamIsUpdate };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(StreamAccessComponent);
